import { configureAtomDevtools as configureAtomDevtoolsBase } from '@localagent/jotai-utils';
import { debugLogEnabled } from '../../lib/debugLog';

// Opt-in, not merely dev: mount/unmount tracing is a debugging aid, and every
// dev session paying for it drowns the console it is meant to help.
export function configureAtomDevtools<A>(atom: A, label: string): A {
  return configureAtomDevtoolsBase(atom, label, { isDev: debugLogEnabled });
}
